import { oz } from '@weft/utils';
import { ApiDateSchema, CurrencySchema } from '../../../primitives';
import { ContractStatusSchema } from '../../contract';

export const CommitmentUsageReportItemSchema = oz.object({
  contractStatus: ContractStatusSchema,
  customerName: oz.string(),
  startDate: ApiDateSchema,
  endDate: ApiDateSchema,
  contractStartDate: ApiDateSchema,
  daysToContractEnd: oz.number().optional(),
  productVariantName: oz.string(),
  commitmentConsumptionCurrencyAmount: oz.number(),
  commitmentConsumptionUnitsAmount: oz.number(),
  commitmentConsumptionPercentage: oz.number(),
  totalCommitmentCurrencyAmount: oz.number(),
  totalCommitmentUnitsAmount: oz.number(),
  commercialTermsAmount: oz.number().optional(),
  erpId: oz.string().optional(),
  currency: CurrencySchema,
}).openapi('GetCommitmentUsageReportItemResponseSchema');

export type CommitmentUsageReportItem = oz.TypeOf<typeof CommitmentUsageReportItemSchema>;